var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _rect2, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M731.653 221.693c-4.871-52.68-92.512-51.73-92.512-51.73s-72.963 78.015-90.098 77.195c-17.135-.82 49.36-78.888 49.36-78.888-31.946-8.793-121.682 16.623-121.682 16.623s-12.631 103.628-29.038 98.615c-16.407-5.013 15.865-91.192 15.865-91.192-33.083 3.964-68.815 35.547-68.815 35.547-47.082 53.358 23.868 111.065 23.868 111.065s-5.151 35.819-34.278 72.862c0 0-6.276 6.684-13.559 18.636l8.57 1.492a82.68 82.68 0 0 1 3.485-6.244c.007-.017.01-.025.026-.039.022-.03.033-.056.055-.086.814-1.22 1.994-2.963 3.444-5.071l.004-.008.003-.008c3.509-4.677 5.944-8.152 7.532-10.688l.01-.026c10.65-14.732 25.601-33.733 33.906-36.816 0 0-.718-1.499-1.154-4.25.371 1.355.746 2.771 1.154 4.25 9.201 33.996 81.662 52.001 123.999 50.726 42.336-1.275 26.526-15.904 7.768-38.445-18.759-22.541-65.733-25.632-78.078-35.34-12.345-9.708 8.84-13.578 35.734-6.743 26.882 6.839 35.776 36.46 79.065 48.312 43.289 11.853 91.24-65.12 91.24-65.12-32.038 4.149-83.627-22.113-83.901-32.954-.271-10.849 80.257 4.242 93.375 3.285 13.14-.957 39.523-22.279 34.652-74.96z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.015 133.489c22.557-42.78 96.173-11.263 96.173-11.263s34.246 91.453 48.99 96.766c14.745 5.313-14.024-83.919-14.024-83.919 30.034 3.771 96.85 56.683 96.85 56.683s-25.629 91.939-10.03 93.456c15.598 1.517 18.546-82.57 18.546-82.57 26.526 14.942 45.616 54.136 45.616 54.136 21.041 61.561-59.03 85.428-59.03 85.428s-8.197 32.054 3.408 73.544c0 0 2.956 7.844 4.915 20.489l-7.753-1.743a76.08 76.08 0 0 0-.754-6.494c0-.017 0-.026-.008-.042-.009-.034-.009-.059-.017-.092-.26-1.316-.645-3.202-1.131-5.489v-.017c-1.322-5.179-2.16-8.967-2.612-11.665v-.026c-3.826-16.173-9.788-37.459-15.716-42.973 0 0 1.13-1.014 2.462-3.184-.787 1.013-1.6 2.078-2.462 3.184-19.668 25.484-87.113 15.294-122.389-.62-35.275-15.914-16.813-22.727 6.908-35.188 23.721-12.462 64.439 1.391 78.254-2.481 13.816-3.872-2.704-14.565-27.79-18.219-25.077-3.645-42.953 18.252-83.629 13.09-40.677-5.162-54.182-86.969-54.182-86.969 25.579 14.732 78.304 10.634 82.332 1.575 4.027-9.067-69.203-24.545-79.938-29.95-10.751-5.414-25.546-32.666-2.989-75.447z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m307.934 219.811-14.829-66.594H250.22",
    stroke: "#69dcdc",
    strokeWidth: 30.865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m347.452 403.067-39.518-183.256h283.891c14.287 0 24.917 13.102 21.935 27.008l-33.687 156.248c-2.22 10.29-11.348 17.634-21.934 17.634H369.364c-10.564 0-19.692-7.344-21.912-17.634z",
    fill: "#69dcdc",
    stroke: "#69dcdc",
    strokeWidth: 30.865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M548.723 478.693c-5.974 0-10.822 4.848-10.764 10.821 0 5.973 4.848 10.821 10.821 10.821 5.974 0 10.822-4.848 10.822-10.821-.029-5.973-4.877-10.821-10.879-10.821m-173.128 0c-5.974 0-10.822 4.848-10.764 10.821-.029 5.973 4.819 10.821 10.792 10.821 5.974 0 10.822-4.848 10.822-10.821s-4.848-10.821-10.85-10.821",
    stroke: "#69dcdc",
    strokeWidth: 39.978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.187 375.195c-21.453 0-38.846-17.393-38.846-38.846 0-21.453 17.393-38.846 38.846-38.846 21.453 0 38.846 17.393 38.846 38.846 0 21.453-17.393 38.846-38.846 38.846z",
    fill: "#69dcdc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m696.396 330.8-15.951 15.538-9.577-9.321",
    stroke: "#fff",
    strokeWidth: 6.539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.269 248.668c-21.759 0-39.401-17.89-39.401-39.956 0-22.066 17.642-39.956 39.401-39.956 21.76 0 39.401 17.89 39.401 39.956 0 22.066-17.641 39.956-39.401 39.956z",
    fill: "#69dcdc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m724.143 202.052-16.645 17.759-9.993-10.654",
    stroke: "#fff",
    strokeWidth: 6.539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.096 285.079c-21.584 0-39.085-17.501-39.085-39.085 0-21.585 17.501-39.085 39.085-39.085 21.585 0 39.085 17.5 39.085 39.085 0 21.584-17.5 39.085-39.085 39.085z",
    fill: "#69dcdc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m212.125 240.072-16.282 16.581-9.775-9.947",
    stroke: "#fff",
    strokeWidth: 6.539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 374.527,
    y: 273.085,
    width: 173.143,
    height: 26.637,
    rx: 11.099,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 374.527,
    y: 336.349,
    width: 173.143,
    height: 26.637,
    rx: 11.099,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M494.874 148.293c19.635-24.296 10.289-64.431 10.289-64.431s-41.178-.716-60.797 23.598c-19.635 24.297-10.305 64.413-10.305 64.413s41.178.716 60.813-23.58z",
    fill: "url(#c)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M738.103 269.756h-.169c-1.003 13.703-11.571 13.914-11.571 13.914s11.654.219 11.654 16.053c0-15.834 11.653-16.053 11.653-16.053s-10.564-.211-11.567-13.914zM401.807 137.679h-.17c-1.003 13.703-11.571 13.914-11.571 13.914s11.654.219 11.654 16.053c0-15.834 11.654-16.053 11.654-16.053s-10.564-.211-11.567-13.914zm-243.066 29.967h-.17C157.568 181.349 147 181.56 147 181.56s11.654.219 11.654 16.053c0-15.834 11.654-16.053 11.654-16.053s-10.564-.211-11.567-13.914zm480.257 234.899c-6.673 1.963-15.567 5.913-20.358 13.112-4.788 7.2 1.539 8.929 9.689 7.176 8.151-1.753 16.068-6.807 19.039-13.503s-2.893-8.396-8.37-6.785z",
    fill: "#E1E4E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.502 409.961h2.867c.694 0 1.252.565 1.252 1.252v2.868c0 .693-.564 1.252-1.252 1.252h-2.867a1.257 1.257 0 0 1-1.252-1.252v-2.868a1.25 1.25 0 0 1 1.252-1.252zm9.942 0h2.868c.687 0 1.251.565 1.251 1.252v2.868c0 .693-.564 1.252-1.251 1.252h-2.868a1.258 1.258 0 0 1-1.252-1.252v-2.868c0-.687.565-1.252 1.252-1.252zm9.949 0h2.868c.687 0 1.251.565 1.251 1.252v2.868c0 .693-.564 1.252-1.251 1.252h-2.868a1.257 1.257 0 0 1-1.252-1.252v-2.868a1.25 1.25 0 0 1 1.252-1.252zm9.943 0h2.868c.687 0 1.252.565 1.252 1.252v2.868c0 .693-.565 1.252-1.252 1.252h-2.868a1.258 1.258 0 0 1-1.257-1.252v-2.868a1.265 1.265 0 0 1 1.257-1.252zm9.943 0h2.868c.693 0 1.257.565 1.257 1.252v2.868c0 .693-.564 1.252-1.257 1.252h-2.868a1.257 1.257 0 0 1-1.252-1.252v-2.868c0-.687.564-1.252 1.252-1.252zm-29.47 10.842h2.868c.687 0 1.251.565 1.251 1.252v2.874c0 .687-.564 1.251-1.251 1.251h-2.868a1.252 1.252 0 0 1-1.252-1.251v-2.868a1.25 1.25 0 0 1 1.252-1.258zm9.943 0h2.867c.688 0 1.252.565 1.252 1.252v2.874c0 .687-.564 1.251-1.252 1.251h-2.867a1.256 1.256 0 0 1-1.252-1.251v-2.868a1.25 1.25 0 0 1 1.252-1.258zm9.943 0h2.867c.694 0 1.258.565 1.258 1.252v2.874c0 .687-.564 1.251-1.258 1.251h-2.867a1.256 1.256 0 0 1-1.252-1.251v-2.868c0-.693.564-1.258 1.252-1.258zm-10.302-22.489h2.868c.687 0 1.251.564 1.251 1.252v2.868c0 .693-.564 1.251-1.251 1.251h-2.868a1.256 1.256 0 0 1-1.252-1.251v-2.868a1.249 1.249 0 0 1 1.252-1.252zm9.943 0h2.868c.687 0 1.252.564 1.252 1.252v2.868c0 .693-.565 1.251-1.252 1.251h-2.868a1.257 1.257 0 0 1-1.257-1.251v-2.868a1.265 1.265 0 0 1 1.257-1.252z",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 383.454,
    y1: 651.593,
    x2: 755.582,
    y2: -213.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 314.276,
    y1: 618.564,
    x2: 303.314,
    y2: -242.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 560.506,
    y1: 52.817,
    x2: 332.109,
    y2: 238.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.036c67d3573f3219fd95e0cc7525b6d8.svg";
export { ForwardRef as ReactComponent };